import React from "react";
import { useNavigate} from "react-router-dom";
import TableData from "../Partials/TableData3";

function Listcompany() {
const path="Company"

const navigate=useNavigate()

const editClick=(item)=>{
// item_id getting from tabledata component through parameter 
navigate(`../addnewcompany/${item._id}`);
}

  return (
    <React.Fragment>
      <div className="add-user-container">
       
      <div className="headingdiv">

     <span className="componet-title">Company List</span>
      
     <div>
    <button onClick={()=>{navigate(-1)}}>Back</button>
      </div>
      
      </div>

        <div className="option-btn">
        <button onClick={()=>{navigate("/addnewcompany")}}>Add New Company</button>
         </div>
      
        <TableData path={path}  editClick={editClick}/>

      
      </div>
    </React.Fragment>
  );
}

export default Listcompany;

